import { pushDataLayerClick } from '../shared/utils';
export const useTrackedSelect = _ref => {
  let {
    trackingState: {
      trackFirstInteraction,
      toolInfo
    },
    onFocus
  } = _ref;
  const handleClick = e => {
    pushDataLayerClick({
      toolInfo,
      itemText: `${e.target?.name} (${e.target?.type} field)`
    });
    trackFirstInteraction();
    if (typeof onFocus === 'function') {
      onFocus(e);
    }
  };
  return {
    onFocus: handleClick
  };
};

///////// IMPLEMENTATION /////////